export const LOYALTY_ROOT = 'loyalty-root';
export const LOYALTY_ROOT_LABEL = 'Лояльность';

export const LOYALTY = 'loyalty';
export const LOYALTY_LABEL = 'Карты лояльности';

export const SEGMENTS = 'segments';
export const SEGMENTS_LABEL = 'Сегменты';

export const CARDS = 'cards';
export const CARDS_LABEL = 'Карты клиентов';

export const BOOKING_LABEL = 'Онлайн записи';
export const BOOKING = 'online-booking';

export const RECOMMEND_APP_LABEL = 'Рекомендуй!';
export const RECOMMEND_APP = 'recommend-app';

export const RECOMMEND_APP_PARTNERS_LABEL = 'Рекомендуй Партнёры';
export const RECOMMEND_APP_PARTNERS = 'recommend-b2b';

export const RECOMMEND_SETTINGS_LABEL = 'Настройки Рекомендуй!';
export const RECOMMEND_SETTINGS = 'settings';
